import { render, staticRenderFns } from "./DecizapGoOffer.vue?vue&type=template&id=21c2b69d&scoped=true&"
import script from "./DecizapGoOffer.vue?vue&type=script&lang=ts&"
export * from "./DecizapGoOffer.vue?vue&type=script&lang=ts&"
import style0 from "./DecizapGoOffer.vue?vue&type=style&index=0&id=21c2b69d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c2b69d",
  null
  
)

export default component.exports